import { render, staticRenderFns } from "./wtMakeNewWochit.component.vue?vue&type=template&id=15253b5a&scoped=true&"
import script from "./wtMakeNewWochit.component.vue?vue&type=script&lang=js&"
export * from "./wtMakeNewWochit.component.vue?vue&type=script&lang=js&"
import style0 from "./wtMakeNewWochit.component.vue?vue&type=style&index=0&id=15253b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15253b5a",
  null
  
)

export default component.exports